export default "__VITE_PUBLIC_ASSET__83e20c98__"